import type { BarPreset } from './bar-chart.model';
export interface LegacyBarAlias {id:string;types:string[];variant:BarPreset;orientation:'horizontal'|'vertical';}
/** Migration identifiers only. No imported bar implementation is retained. */
export const LEGACY_BAR_ALIASES:readonly LegacyBarAlias[]=[
  {
    "id": "dvm:chart-components/bar-chart/bar-chart.component#BarChartComponent",
    "types": [
      "bar-chart"
    ],
    "variant": "vertical",
    "orientation": "vertical"
  },
  {
    "id": "dvm:chart-components/clustered-bar-chart/clustered-bar-chart.component#ClusteredBarComponent",
    "types": [
      "clustered-bar-chart"
    ],
    "variant": "grouped",
    "orientation": "horizontal"
  },
  {
    "id": "dvm:chart-components/comparison-bar-chart/comparison-bar-chart.component#ComparisonBarChartComponent",
    "types": [
      "comparison-bar-chart"
    ],
    "variant": "grouped",
    "orientation": "vertical"
  },
  {
    "id": "dvm:chart-components/generic-stackbar-chart/generic-stackbar-chart#GenericStackbarChart",
    "types": [
      "generic-stack-bar-chart",
      "stack-bar-chart-generic"
    ],
    "variant": "stacked",
    "orientation": "vertical"
  },
  {
    "id": "dvm:chart-components/grouped-bar-chart-with-status-table/grouped-bar-chart-with-status-table.component#GroupedBarChartWithStatusTableComponent",
    "types": [
      "grouped-bar-chart-with-status-table"
    ],
    "variant": "grouped",
    "orientation": "vertical"
  },
  {
    "id": "dvm:chart-components/horizontal-bar-chart-segment/horizontal-bar-chart-segment.component#HorizontalBarChartSegmentComponent",
    "types": [
      "horizontal-bar-chart-segment"
    ],
    "variant": "stacked",
    "orientation": "horizontal"
  },
  {
    "id": "dvm:chart-components/horizontal-bar-chart/horizontal-bar-chart.component#HorizontalBarChartComponent",
    "types": [
      "horizontal-bar-chart"
    ],
    "variant": "horizontal",
    "orientation": "horizontal"
  },
  {
    "id": "dvm:chart-components/mixed-stackbar-chart/mixed-stackbar-chart.component#MixedStackbarChartComponent",
    "types": [
      "mixed-stackbar-chart"
    ],
    "variant": "stacked",
    "orientation": "vertical"
  },
  {
    "id": "dvm:chart-components/multi-level-comparison-chart/multi-level-comparison-chart.component#MultiLevelComparisonChartComponent",
    "types": [
      "multi-level-comparison-chart"
    ],
    "variant": "grouped",
    "orientation": "vertical"
  },
  {
    "id": "dvm:chart-components/named-bar-chart-with-division/named-bar-chart-with-division.component#NamedBarChartWithDivisionComponent",
    "types": [
      "named-bar-chart-with-division"
    ],
    "variant": "grouped",
    "orientation": "vertical"
  },
  {
    "id": "dvm:chart-components/stack-bar-chart/stack-bar-chart.component#StackBarChartComponent",
    "types": [
      "stack-bar-chart"
    ],
    "variant": "stacked",
    "orientation": "vertical"
  },
  {
    "id": "dvm:chart-components/stacked-barchart-hundred-percentage/stacked-barchart-hundred-percentage.component#Stacked100BarComponent",
    "types": [
      "stacked-100-bar-chart"
    ],
    "variant": "percent",
    "orientation": "vertical"
  },
  {
    "id": "dvm:chart-components/stacked-horizontal-bar-chart/stacked-horizontal-bar-chart.component#StackedHorizontalBarChartComponent",
    "types": [
      "stacked-horizontal-bar-chart"
    ],
    "variant": "stacked",
    "orientation": "horizontal"
  }
];
export function legacyBarAlias(idOrType?:string):LegacyBarAlias|undefined {return LEGACY_BAR_ALIASES.find(item=>item.id===idOrType || item.types.includes(idOrType??'') || item.id.split('/')[1]===idOrType);}
